<template>
  <div>
    <div class="content-bg">
      <div class="content-border-wrapper artwork">
        <div class="cw-section artwork-info">
          <div class="pic"><img :data-src="info.imageUrl | imageUrl" :src="info.imageUrl | imageUrl('?imageView2/2/w/638')" /></div>
          <h1>{{info.name}}</h1>
          <p>
            <span>{{info.author}}</span>
            <span v-if="info.material">&nbsp;&nbsp;|&nbsp;&nbsp;{{info.material}}</span>
            <span v-if="info.size">; {{info.size}}</span>
            <span v-if="info.year">, {{info.year}}</span>
          </p>
        </div>
        <section class="cw-section detail" v-if="subject">
          <div class="hd cw-hd">
            <h2 class="title">作品介绍</h2>
          </div>
          <div class="bd" v-html="subject"></div>
        </section>
        <!-- <section class="cw-section">
        <div class="hd">
          <h2 class="title">艺术家介绍</h2>
        </div>
        <div class="bd"></div>
      </section> -->
      </div>
    </div>
    <appbar></appbar>
  </div>
</template>
<script>
import appbar from '../common/appbar'
import { getArtworkDetail } from '@/api/zaiart'
import { resolveContent } from '@/utils/filters'
export default {
  components: { appbar },
  data() {
    return {
      pageId: null,
      info: {}
    }
  },
  computed: {
    subject() {
      // resolveContent(value, maxWidth)
      return resolveContent(this.info.subject, '638')
    }
  },
  methods: {
    init() {
      this.getDetailData()
    },
    getDetailData() {
      const param = { id: this.pageId }
      return getArtworkDetail(param).then(response => {
        this.info = response.data.info
      })
    }
  },
  created() {
    this.pageId = this.$route.params.id
    this.init()
  }
}
</script>
<style>
.artwork .artwork-info .pic {
  text-align: center;
}
.artwork .artwork-info .pic img {
  max-width: 100%;
}
.artwork .artwork-info h1 {
  margin-top: 40px;
  margin-bottom: 20px;
  padding-bottom: 16px;
  font-size: 28px;
  font-weight: normal;
  line-height: 44px;
  color: #333;
  border-bottom: dashed 1px #dadada;
}
.artwork .artwork-info p {
  font-size: 16px;
  line-height: 20px;
  color: #666;
}
.artwork .artwork-info p span {
  display: inline-block;
}
.artwork .detail {
  font-size: 16px;
  color: #333;
  line-height: 28px;
}
.artwork .detail p:first-child {
  margin-top: 0 !important;
}
.artwork .detail p {
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 20px;
}
.artwork .detail p:last-child {
  margin-bottom: 0;
}
.artwork .detail img {
  max-width: 100%;
}
</style>
